import { History } from 'history';
import { action } from 'satcheljs';

export const onChangeReportId = action('onChangeReportId', (reportId?: string, history?: History<unknown>) => ({
  reportId,
  history,
}));
